import Analytics from 'analytics';
import googleAnalytics from '@analytics/google-analytics';
// import doNotTrack from 'analytics-plugin-do-not-track';
import tabEventsPlugin from 'analytics-plugin-tab-events';
import windowEventsPlugin from 'analytics-plugin-window-events';

import { country, language } from './localization';
import { currency } from './money';
import version from './version.json';

const analytics = Analytics({
  app: 'AI on Rails',
  version,
  plugins: [
    googleAnalytics({
      measurementIds: __DEV__ ? ['G-32FN23KCTF'] : ['G-32FN23KCTF'],
    }),
    // doNotTrack(), // FIXME(clairbee): broken on Safari?
    tabEventsPlugin(),
    windowEventsPlugin(),
  ],
});

analytics.on('tabHidden', () => {
  // console.log('tab hidden');
});
analytics.on('tabVisible', () => {
  // console.log('tab visible');
});
analytics.on('windowEnter', () => {
  // console.log('window entered');
});
analytics.on('windowLeft', () => {
  // console.log('window left');
});

const create = (userIdentity, userHash) => {
  console.log('analytics.create()');
  console.log(userIdentity);
  console.log(userHash);

  analytics.identify(userIdentity, {
    country,
    language: language(),
    currency,
    userHash,
  });
};

const page = (title, path) => {
  console.log('analytics.page()');
  console.log(title);
  console.log(path);

  analytics.page({
    title,
    path,
  });

  analytics.track('page_view', {
    page_title: title,
    page_location: path,
  });
};

const event = (action, category, label, value) => {
  // console.log('analytics.event()');
  // console.log(action);
  // console.log(category);
  // console.log(label);
  // console.log(value);

  analytics.track(action, {
    category,
    label,
    value,
  });
};

const error = (err) => {
  let label = 'generic';
  let value = JSON.stringify(err);
  if (err.code && err.message) {
    label = err.code;
    value = err.message;
  }
  event('error', 'error', label, value);
};

export default {
  create,
  page,
  event,
  error,
};
